/**
 * Los tipos de documento que emite cada clase de terminal. Copia de
 * `TIPOS_DEL_POS` y `TIPOS_DEL_AGENTE` de `apps/pos/serializers.py`.
 */
export type ClaseDeTerminal = 'pos' | 'agente'

const NOMBRES: Record<number, string> = {
  33: 'Factura',
  34: 'Factura exenta',
  39: 'Boleta',
  41: 'Boleta exenta',
  43: 'Liquidación factura',
  46: 'Factura de compra',
  52: 'Guía de despacho',
  56: 'Nota de débito',
  61: 'Nota de crédito',
  110: 'Factura de exportación',
  111: 'Nota de débito de exportación',
  112: 'Nota de crédito de exportación',
}

export const TIPOS_POR_CLASE: Record<ClaseDeTerminal, number[]> = {
  pos: [39, 41, 33, 34, 61],
  agente: [33, 34, 39, 41, 43, 46, 52, 56, 61, 110, 111, 112],
}

export const CLASES: { value: ClaseDeTerminal; label: string }[] = [
  { value: 'pos', label: 'Punto de venta' },
  { value: 'agente', label: 'Clobi Conector (sistema de gestión)' },
]

export const nombreDelTipo = (code: number) => `${NOMBRES[code] ?? 'Tipo'} (${code})`
